import { useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { ReportGetTemplates, ReportGetTemplatesResponse } from '../../api/dtos';

const getData = (response?: SWRResponse<ReportGetTemplatesResponse, ReportGetTemplatesResponse>) => {
    return response?.data?.reportTemplates;
}
const getError = (response?: SWRResponse<ReportGetTemplatesResponse, ReportGetTemplatesResponse>) => (response?.error ?? response?.data)?.responseStatus;
// const getAdditionalState = (response?: SWRResponse<StageGetSummaryCollectionByProjectIdResponse, StageGetSummaryCollectionByProjectIdResponse>) => ({});

const useReportTemplates = (configuration?: SWRConfiguration<ReportGetTemplatesResponse, ReportGetTemplatesResponse>) => {
    const request = useMemo(() => {
        return () => {
            return new ReportGetTemplates();
        };
    }, [])

    return useGet(request, { getData, getError }, configuration);
}

export default useReportTemplates;